const IdentityVerificationQuestionTypeEnum = {
  SINGLE: 'single',
};

export default IdentityVerificationQuestionTypeEnum;
